import { useEffect } from "react";
import { useSelector } from "react-redux";
import { usePresenceHeartbeatMutation } from "state/api";

const HEARTBEAT_MS = 2 * 60 * 1000;

/** Ping server while the app is open so team presence reflects live activity. */
const PresenceHeartbeat = () => {
  const user = useSelector((state) => state.global.user);
  const twoFactorRequired = useSelector((state) => state.global.twoFactorRequired);
  const [sendHeartbeat] = usePresenceHeartbeatMutation();

  useEffect(() => {
    if (!user?._id || twoFactorRequired) return undefined;

    const ping = () => {
      sendHeartbeat().catch(() => {});
    };

    ping();
    const id = setInterval(ping, HEARTBEAT_MS);
    return () => clearInterval(id);
  }, [user?._id, twoFactorRequired, sendHeartbeat]);

  return null;
};

export default PresenceHeartbeat;
